import React from 'react';
import { bool, object, string } from 'prop-types';
import classNames from 'classnames';

import MaterialSymbol from '../MaterialSymbol/MaterialSymbol';
import css from './ExternalBookingBadge.module.css';

/**
 * Marks a reservation the host brought in from off-platform.
 *
 * Once the bañista pays, an external booking becomes an ordinary transaction and is
 * indistinguishable in the lists — but it carries a reduced commission and a price
 * the host set themselves, so they need to recognise it at a glance.
 *
 * Provider-only: the bañista knows how they got here, and the commission arrangement
 * is between the host and Cocopool. Reads `metadata.externalBooking` — see
 * docs/external-bookings.md.
 */
const ExternalBookingBadge = props => {
  const { className, externalBooking, isProvider } = props;

  if (!isProvider || !externalBooking) {
    return null;
  }

  return (
    <span className={classNames(css.badge, className)}>
      <MaterialSymbol name="shield" size={14} />
      Reserva externa
    </span>
  );
};

ExternalBookingBadge.defaultProps = { className: null, externalBooking: null };
ExternalBookingBadge.propTypes = {
  className: string,
  externalBooking: object,
  isProvider: bool.isRequired,
};

export default ExternalBookingBadge;
